import React from 'react'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import KeyboardIcon from 'Assets/icons/keyboard.svg'
import styles from './KeyboardShortcuts.module.less'

const shortcuts = [
    {
        label: 'Deselect Class',
        key: 'ESC',
    },
]

const KeyboardShortcuts: React.FC = () => {
    return (
        <div
            className={styles['keyboard-shortcuts-container']}
            data-testid="keyboard-shortcuts-container"
        >
            <PanelHeader title={'Keyboard Shortcuts'} logo={KeyboardIcon} />
            <div className={styles['keyboard-shortcut']}>
                {shortcuts.map(shortcut => (
                    <div
                        className={styles['shortcut-item']}
                        key={shortcut.label}
                        data-testid="keyboard-shortcut"
                    >
                        <span className={styles['shortcut-label']}>{shortcut.label}</span>
                        <span className={styles['shortcut-value']}>{shortcut.key}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default KeyboardShortcuts
